/**
 * Accessible password requirements hint: bullet list at base font size and primary text colour.
 * Used on Register (and optionally Login) so requirements are easy to read for accessibility users.
 * See docs/implementation-checklist-7.1-password-requirements.md
 */
interface PasswordRequirementsHintProps {
  /** ID for the container so the password input can use aria-describedby. */
  id: string
  /** Optional visible label above the list (e.g. "Password must:"). */
  showLabel?: boolean
}

const REQUIREMENTS = [
  'At least 8 characters',
  'Include both letters and numbers',
] as const

export default function PasswordRequirementsHint({
  id,
  showLabel = true,
}: PasswordRequirementsHintProps) {
  return (
    <div
      id={id}
      className="mt-2 text-base text-text-primary"
      role="region"
      aria-label={showLabel ? 'Password requirements' : undefined}
    >
      {showLabel && (
        <p className="font-semibold mb-1" id={`${id}-label`}>
          Password must:
        </p>
      )}
      <ul className="list-disc pl-5 space-y-1">
        {REQUIREMENTS.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </div>
  )
}
